import { Story, IANSReference } from './ans'

export interface PubstackDocument {
  id: string
  draft_revision_id?: string
  published_revision_id?: string
  first_published_at?: string
  last_published_at?: string
  first_unpublished_at?: string
  last_unpublished_at?: string
  type: string
  created_at: string
}

export interface PubstackRevision {
  id: string
  document_id: string
  ans: Omit<Story, '_id' | 'additional_properties'> & {
    additional_properties: {
      has_published_copy: boolean
      is_published?: boolean
    }
  }
  user_id?: string
  created_at: string
  unpublished_at?: string
  type?: string | 'PUBLISHED' | 'DRAFT'
}

export interface PubstackRevisions {
  revisions: PubstackRevision[]
}
export interface DenormalizedSection {
  name: string
  type: string
  version: string
  _id?: string
}

export interface Circulation {
  document_id: string
  website_id: string
  website_url?: string
  website_primary_section?: IANSReference
  website_sections?: IANSReference[]
  success?: boolean | null
  errorCode?: number | null
}

export interface Lock {
  id: string
  attribute: 'DOCUMENT' | 'CIRCULATIONS'
  entity_id: string
  user_id: string
  app_id: string
  updated_at: string
  created_at: string
  display_name: string
}
